import { useEffect } from 'react';
import { useAuthManager } from '../contexts/authManager';

const LogoutPage = () => {
  const { requestLogoutRedirect } = useAuthManager();

  useEffect(() => {
    void requestLogoutRedirect('/');
  }, [requestLogoutRedirect]);

  return <p>Logging out...</p>;
};

export default LogoutPage;
